import { createSlice } from '@reduxjs/toolkit'

import { checkTrialExtensionEligibility } from './actions/check_trial_extension_eligibility'
import { extendTrial } from './actions/extend_trial'

const initialState = {
  trialExtensionLoading: false,
  extendedDays: null,
  success: null,
  eligibilityCheckLoading: false,
  eligibleForExtension: null,
}

const trialExtensionSlice = createSlice({
  name: 'trialExtension',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(extendTrial.pending, (state) => {
      state.trialExtensionLoading = true
      state.extendedDays = null
      state.success = null
    })
    builder.addCase(extendTrial.fulfilled, (state, action) => {
      state.trialExtensionLoading = false
      state.extendedDays = action.payload.extended_days
      state.success = true
    })
    builder.addCase(extendTrial.rejected, (state) => {
      state.trialExtensionLoading = false
      state.success = false
    })
    builder.addCase(checkTrialExtensionEligibility.pending, (state) => {
      state.eligibilityCheckLoading = true
      state.eligibleForExtension = null
    })
    builder.addCase(checkTrialExtensionEligibility.fulfilled, (state) => {
      state.eligibilityCheckLoading = false
      state.eligibleForExtension = true
    })
    builder.addCase(checkTrialExtensionEligibility.rejected, (state) => {
      state.eligibilityCheckLoading = false
      state.eligibleForExtension = false
    })
  }
})

export const {
  reducer
} = trialExtensionSlice
